import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthForm from './AuthForm';

const DashboardAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  // Vérifie si l'utilisateur est déjà authentifié dans cette session
  useEffect(() => {
    const authStatus = sessionStorage.getItem('dashboardAuthenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
      navigate('/dashboard');
    }
  }, [navigate]);

  // Fonction pour gérer l'authentification réussie
  const handleAuthentication = (status) => {
    setIsAuthenticated(status);
    if (status) {
      sessionStorage.setItem('dashboardAuthenticated', 'true');
      navigate('/dashboard');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-100 via-indigo-50 to-purple-100 flex flex-col items-center justify-center pt-20 pb-10 px-4">
      <div className="w-full max-w-xl bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
        <div className="p-6">
          <div className="text-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">Dashboard - accès restreint</h1>
            <p className="text-gray-600 mt-2">
              Ce dashboard est réservé à l'administrateur du site web. 
              Veuillez vous authentifier pour continuer.
            </p>
          </div>
          
          <AuthForm onAuthenticated={handleAuthentication} context="dashboard" />
        </div>
      </div>
    </div>
  );
};

export default DashboardAuth; 